import Vue from 'vue'
import advertiserDisclosure from './advertiser-disclosure.vue'

new Vue({
  el: '#advertiser-disclosure',
  render: h => h(advertiserDisclosure)
})
